<script lang="ts">
	import IconButton from '../../../../basic/buttons/IconButton.svelte';
	import { contextMenuState } from '../../../../basic/contextmenu/ContextMenuStore';
	import { confirmState } from '../../../../basic/dialog/ConfirmStore';
	import { getColorForString } from '../../../../helper/Colors';
	import type { SettingPaymentPeriod } from '../../../../types/BasicTypes';
	import type { MultiSelectionItem } from '../../../../types/ListTypes';
	import { _ } from 'svelte-i18n';
	import { type SettingPaymentPeriodStore } from '../../../../stores/SettingPaymentPeriodsStore.svelte';

	interface Props {
		store: SettingPaymentPeriodStore;
		item: SettingPaymentPeriod;
		onClick: (e: MouseEvent) => void;
		onEditRequest: (item: MultiSelectionItem) => void;
	}

	let { store, item, onClick, onEditRequest }: Props = $props();

	let showMenu: boolean = $state(false);

	async function openContextMenu(e: MouseEvent) {
		e.stopPropagation();

		const menuItems = [
			{
				title: $_('general.lbl_edit'),
				callbackFunction: () => {
					onEditRequest(item);
				}
			},
			{
				title: $_('general.lbl_delete'),
				danger: true,
				callbackFunction: () => {
					$confirmState = {
						bodyText: $_('settings.basic.payment_periods.lbl_delete_modal').replace(
							'{}',
							item.defaultName
						),
						successCallback: () => store.deleteSettingPaymentPeriodStore(item),
						warningText: $_('settings.basic.payment_periods.lbl_delete_warning'),
						securityCheckText: item.defaultName,
						acceptButtonText: $_('general.lbl_delete')
					};
				}
			}
		];

		$contextMenuState = {
			x: e.clientX,
			y: e.clientY,
			menuItems: menuItems
		};
	}
</script>

<button
	onclick={onClick}
	onmouseenter={() => {
		showMenu = true;
	}}
	onmouseleave={() => {
		showMenu = false;
	}}
	class="rounded-[5px] bg-white dark:bg-dark-400 p-4 text-left relative"
	oncontextmenu={(e: MouseEvent) => {
		e.preventDefault();
		openContextMenu(e);
	}}
>
	<div>
		<div class="flex gap-2 items-center">
			<div
				class="w-4 h-4 rounded flex-shrink-0"
				style="background-color: {getColorForString(item.defaultName)};"
			></div>
			<p class="truncate font-bold">{item.defaultName}</p>
		</div>

		<div class="absolute bottom-2 right-2">
			{#if showMenu}
				<IconButton
					iconName="ellipsis-h"
					onClick={openContextMenu}
					showCircle={false}
					size="small"
				/>
			{/if}
		</div>
	</div>
</button>
